import { DateHelper } from "@bryntum/schedulerpro";
import { FormattedFile } from "@/react/components/entityViews/files/context/EntityFileContext";

export type MetadataRow = {
  label: string;
  value: string;
};

/**
 * Formats file metadata into display rows
 */
export const formatFileMetadata = (file: FormattedFile | null): MetadataRow[] => {
  if (!file) return [];

  const uploadedAt = file.record?.originalData?.created_at || file.lastUpdatedAt;
  const uploadedDate = uploadedAt ? DateHelper.format(new Date(uploadedAt), "MM/DD/YYYY") : "";
  const uploadedBy = file.addedBy ?? "";
  const lastUpdatedDate = file.lastUpdatedAt ? DateHelper.format(new Date(file.lastUpdatedAt), "MM/DD/YYYY") : "";
  const lastUpdatedBy = file.lastUpdatedBy ?? "";

  const sourceLabel = file.isCCImage ? "CompanyCam" : "Swivu";
  const sizeLabel = file.size && file.size !== "N/A" ? file.size : "";
  const uploadedLabel = uploadedDate ? `${uploadedDate}${uploadedBy ? ` • ${uploadedBy}` : ""}` : uploadedBy ? `Uploaded by ${uploadedBy}` : "";
  const updatedLabel = lastUpdatedDate ? `${lastUpdatedDate}${lastUpdatedBy ? ` • ${lastUpdatedBy}` : ""}` : lastUpdatedBy;

  return [
    { label: "Source", value: sourceLabel },
    { label: "File size", value: sizeLabel || "" },
    { label: "Uploaded", value: uploadedLabel || "" },
    { label: "Last updated", value: updatedLabel || "" },
    { label: "Age", value: String(file.record?.aging || file.age || "") }
  ].filter((item) => Boolean(item.value));
};
